export default {
	opsiDisplay: "",
	transactionCode: "",
	error: null,
}
